import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { VendorService } from '../../../services/vendor.service';
import { Router } from '@angular/router';
import { PrintService } from '../../../services/print.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { buildDashboardThemeVars } from '../../../shared/dashboard-widget-theme';

@Component({
	selector: 'app-vendordash-ready-to-pay',
	templateUrl: './vendordash-ready-to-pay.component.html',
	styleUrls: ['./vendordash-ready-to-pay.component.scss'],
	animations: [
	  trigger('flipState', [
		  state('active', style({
			  transform: 'rotate3d(0, 1, 0, 179deg)',
		  })),
		  state('inactive', style({
			  transform: 'rotateY(0)'
		  })),
		  transition('active => inactive', animate('500ms ease-out')),
		  transition('inactive => active', animate('500ms ease-in')),
	  ]),
	]
})
export class VendordashReadyToPayComponent implements OnInit {

	flip = 'inactive';
	@Output() viewData = new EventEmitter<any>();

	readyToPay: any = [];
	readyToPayLoaded = false;
	viewing: any = false;
	title: any = '';
	exporting = false;
	@ViewChild('print_table') printtable: ElementRef;

	get themeVars(): Record<string, string> {
		return buildDashboardThemeVars('cw', 'warning');
	}

	constructor(
		private vendorService: VendorService,
		private router: Router,
		private printService: PrintService,
		private globalSearchService: GlobalSearchService
	) {}

	ngOnInit(): void {
		this.vendorService.getDashBoard().subscribe((results: any) => {
			this.readyToPay = results?.readyToPay || [];
			this.readyToPayLoaded = true;
		});
	}

	toggleFlip(data: any, title: string) {
		if (!data) {
			this.flip = 'inactive';
		} else {
			this.flip = (this.flip == 'active') ? 'inactive' : 'active';
		}

		if (this.flip == 'active') {
			this.viewing = data;
			this.title = title;
			const dashboard_data = { data: data, title: 'Ready To Pay' };
			this.viewData.emit(dashboard_data);
		} else {
			this.viewing = false;
			this.viewData.emit(false);
		}
	}

	navigateToVendor(supplierid: string) {
		this.router.navigate(['/vendors', supplierid]);
	}

	exportPdf() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'ready-to-pay.pdf',
			landscape: true,
			title: 'Ready To Pay',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.pdf(data).subscribe((result: any) => {
			this.globalSearchService.downloadPdf(result.content, data.filename);
			this.exporting = false;
		});
	}

	exportXls() {
		this.exporting = true;
		const encoded: string = this.globalSearchService.base64encode(this.printtable.nativeElement.innerHTML);
		const today = new Date();
		const data = {
			content: encoded,
			filename: 'ready-to-pay.xlsx',
			title: 'Ready To Pay',
			subtitle: 'Created ' + today.toLocaleString()
		};
		this.printService.xls(data).subscribe((result: any) => {
			this.globalSearchService.downloadXls(result.content, data.filename);
			this.exporting = false;
		});
	}

	getAmount(v: any): number {
		const amount = this.parseNumber(v.ovamount);
		const gst = this.parseNumber(v.ovgst);
		const fee = this.parseNumber(v.ovfee);
		return amount + gst + fee;
	}

	getBalance(v: any): number {
		return this.parseNumber(v.balance);
	}

	private parseNumber(value: any): number {
		if (value == null || value === '') {
			return 0;
		}
		if (typeof value === 'number') {
			return value;
		}
		if (typeof value === 'string') {
			const cleaned = value.toString().replace(/[^\d.-]/g, '');
			const parsed = parseFloat(cleaned);
			return isNaN(parsed) ? 0 : parsed;
		}
		return 0;
	}

}
